import { defineEvent, type EventPayload } from '@nexus/core';
import { z } from 'zod';

// Events carry IDs, never personal data: subscribers load what they need through the public API.

export const projectCreated = defineEvent('projects.project.created', z.object({ id: z.uuid() }));
export type ProjectCreated = EventPayload<typeof projectCreated>;

export const projectUpdated = defineEvent('projects.project.updated', z.object({ id: z.uuid() }));
export type ProjectUpdated = EventPayload<typeof projectUpdated>;

/** Workflow transition, e.g. to `closed`: inspections can stop planning visits. */
export const projectStatusChanged = defineEvent(
  'projects.project.status-changed',
  z.object({ id: z.uuid(), status: z.string() }),
);
export type ProjectStatusChanged = EventPayload<typeof projectStatusChanged>;

export const projectArchived = defineEvent(
  'projects.project.archived',
  z.object({ id: z.uuid(), archived: z.boolean() }),
);
export type ProjectArchived = EventPayload<typeof projectArchived>;

export const objectCreated = defineEvent('projects.object.created', z.object({ id: z.uuid() }));
export type ObjectCreated = EventPayload<typeof objectCreated>;

export const objectUpdated = defineEvent('projects.object.updated', z.object({ id: z.uuid() }));
export type ObjectUpdated = EventPayload<typeof objectUpdated>;
